// Navbar.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaHome, FaUser, FaLaptopCode, FaCertificate, FaBlog, FaEnvelope } from 'react-icons/fa';
import { RiMenu4Line, RiCloseLine } from 'react-icons/ri';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
 
  const navItems = [
    { path: '/', name: 'Home', icon: FaHome },
    { path: '/about', name: 'About', icon: FaUser },
    { path: '/projects', name: 'Projects', icon: FaLaptopCode },
    { path: '/certifications', name: 'Certifications', icon: FaCertificate },
    { path: '/blogs', name: 'Blogs', icon: FaBlog },
    { path: '/contact', name: 'Contact', icon: FaEnvelope }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <motion.div
          className="logo"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
        >
          <Link to="/">
            <motion.span 
              className="logo-text"
              whileHover={{ 
                scale: 1.05,
                color: '#4ecdc4',
                transition: { duration: 0.2 }
              }}
            >
              Rahul Mishra
            </motion.span>
          </Link>
        </motion.div>

        {/* Desktop Navigation */}
        <div className="nav-links">
          {navItems.map((item) => {
            const IconComponent = item.icon;
            return (
              <motion.div
                key={item.path}
                className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
              >
                <Link to={item.path}>
                  <IconComponent className="nav-icon" />
                  <span>{item.name}</span>
                </Link>
              </motion.div>
            );
          })}
        </div>

        {/* Rest of the code remains the same */}
        <motion.button
          className="mobile-menu-btn"
          onClick={() => setIsOpen(!isOpen)}
          whileTap={{ scale: 0.9 }}
        >
          {isOpen ? <RiCloseLine /> : <RiMenu4Line />}
        </motion.button>

        <motion.div
          className={`mobile-nav ${isOpen ? 'open' : ''}`}
          initial={false}
          animate={isOpen ? { x: 0 } : { x: '100%' }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
        >
          {navItems.map((item) => {
            const IconComponent = item.icon;
            return (
              <motion.div
                key={item.path}
                className={`mobile-nav-item ${location.pathname === item.path ? 'active' : ''}`}
                whileHover={{ x: 10 }}
                whileTap={{ scale: 0.95 }}
              >
                <Link to={item.path}>
                  <IconComponent className="nav-icon" />
                  <span>{item.name}</span>
                </Link>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </nav>
  );
};

export default Navbar;
